module.exports = __webpack_public_path__ + "static/img/vampire_garkain.5d264db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/vampire_garkain.png
// module id = 4Ruq
// module chunks = 0